export const VERIFIED_TYPES = ['none', 'blue', 'business', 'government'] as const;
export type VerifiedType = (typeof VERIFIED_TYPES)[number];
export type VerifiedTypeSource = 'explicit' | 'derived-verified' | 'derived-none';

export function toVerifiedType(input: unknown): VerifiedType {
  let candidate: string;
  if (typeof input === 'string') {
    candidate = input;
  } else if (typeof input === 'number' || typeof input === 'boolean') {
    candidate = String(input);
  } else {
    candidate = 'none';
  }

  return isVerifiedType(candidate) ? candidate : 'none';
}

const isVerifiedType = (value: string): value is VerifiedType => (VERIFIED_TYPES as readonly string[]).includes(value);
